import { Card, CardHeader, CardTitle } from "../Card"
import { Table, TableHeader, TableRow, TableHead, TableBody, TableCell } from "../Table"
import { Tooltip } from "../Tooltip"
import { api } from "../../../utils/api"
import { startCase } from "lodash"

const ReplacementLinksOverview = () => {
  const { data: linkedSkus } = api.healthCheck.linkedSkus.useQuery()

  return (
    <Card className="h-fit">
      <CardHeader>
        <CardTitle>Information about replacement links</CardTitle>
      </CardHeader>
      <Table>
        <TableHeader>
          <TableRow className="text-left text-sm font-normal">
            <TableHead>Company</TableHead>
            <TableHead>Links</TableHead>
            <TableHead>User generated</TableHead>
            <TableHead>System generated</TableHead>
            <TableHead>Variants</TableHead>
            <TableHead>Anomalies</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {linkedSkus?.length ? (
            linkedSkus.map((row) => (
              <TableRow key={row.orgId}>
                <TableCell>
                  <Tooltip title={`Org ID: ${row.orgId}`}>
                    <div>{startCase(row.orgId)}</div>
                  </Tooltip>
                </TableCell>
                <TableCell>{row.linkedSkus}</TableCell>
                <TableCell>{row.userGenerated}</TableCell>
                <TableCell>{row.systemGenerated}</TableCell>
                <TableCell>{row.linkedVariants}</TableCell>
                <TableCell>
                  {row.anomalies > 0 ? (
                    <Tooltip
                      title={`Orphan survivors: ${row.orphanSurvivors}, active originals: ${row.activeOriginals}, self-links: ${row.selfLinks}, multiple primary: ${row.multiplePrimary}`}
                    >
                      <div className="font-medium text-destructive">{row.anomalies}</div>
                    </Tooltip>
                  ) : (
                    <div>0</div>
                  )}
                </TableCell>
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell className="text-center italic" colSpan={6}>
                No replacement links have been created on companies
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </Card>
  )
}

export default ReplacementLinksOverview
